import { atom } from "jotai";

export const intentSearchTypeAtom = atom<"intent" | "intentSentence">("intent");
